import { ServiceState, ServiceType } from "../types";

export const SERVICE_STATE_LABEL = {
  [ServiceState.ServiceRequested]: "Service Requested",
  [ServiceState.ServiceInReview]: "Service In Review",
  [ServiceState.ServiceAwaitingResponse]: "Awaiting Partner Response",
  [ServiceState.ServiceAwaitingProduct]: "Partner Awaiting Product",
  [ServiceState.ServiceProductTransit]: "Product in Transit",
  [ServiceState.InService]: "Service In Progress",
  [ServiceState.ServiceReady]: "Service Ready for Use",
  [ServiceState.ServiceAwaitingAcceptance]: "Awaiting User Acceptance",
  [ServiceState.ServiceCancelledUser]: "Service Cancelled by User",
  [ServiceState.ServiceCancelledPartner]: "Service Cancelled by Partner",
  [ServiceState.ServiceSolutionRejected]: "Solution Rejected",
};

export const SERVICE_TYPE_LABEL = {
  [ServiceType.Cleaning]: "Cleaning",
  [ServiceType.Maintenance]: "Maintenance",
  [ServiceType.Repair]: "Repair",
  [ServiceType.SoftwareUpdate]: "Software Update",
  [ServiceType.ReplacingParts]: "Replacing Parts",
};

export const SERVICE_STATE_COLOR = {
  [ServiceState.ServiceRequested]: "#2196F3",
  [ServiceState.ServiceInReview]: "#42A5F5",
  [ServiceState.ServiceAwaitingResponse]: "#FFEB3B",
  [ServiceState.ServiceAwaitingProduct]: "#FFD54F",
  [ServiceState.ServiceProductTransit]: "#29B6F6",
  [ServiceState.InService]: "#FFA726",
  [ServiceState.ServiceReady]: "#00796B",
  [ServiceState.ServiceAwaitingAcceptance]: "#26C6DA",
  [ServiceState.ServiceCancelledUser]: "#F44336",
  [ServiceState.ServiceCancelledPartner]: "#E53935",
  [ServiceState.ServiceSolutionRejected]: "#D32F2F",
};

export const SERVICE_STATE_TEXT_COLOR = {
  [ServiceState.ServiceRequested]: "#FFFFFF",
  [ServiceState.ServiceInReview]: "#FFFFFF",
  [ServiceState.ServiceAwaitingResponse]: "#000000",
  [ServiceState.ServiceAwaitingProduct]: "#000000",
  [ServiceState.ServiceProductTransit]: "#FFFFFF",
  [ServiceState.InService]: "#000000",
  [ServiceState.ServiceReady]: "#FFFFFF",
  [ServiceState.ServiceAwaitingAcceptance]: "#000000",
  [ServiceState.ServiceCancelledUser]: "#FFFFFF",
  [ServiceState.ServiceCancelledPartner]: "#FFFFFF",
  [ServiceState.ServiceSolutionRejected]: "#FFFFFF",
};
